import { apiClient } from "./client";

export const adminApi = {
  listarUsuarios({
    busca,
    tipo,
    ativo,
    instituicaoId,
    page = 1,
    pageSize = 20,
  } = {}) {
    const params = new URLSearchParams();
    if (busca) params.set("busca", busca);
    if (tipo != null) params.set("tipo", String(tipo));
    if (ativo != null) params.set("ativo", String(ativo));
    if (instituicaoId) params.set("instituicaoId", instituicaoId);
    params.set("page", String(page));
    params.set("pageSize", String(pageSize));
    return apiClient.get(`/admin/usuarios?${params.toString()}`);
  },

  criarUsuario(payload) {
    return apiClient.post("/admin/usuarios", payload);
  },

  editarUsuario(id, payload) {
    return apiClient.patch(`/admin/usuarios/${id}`, payload);
  },

  excluirUsuario(id) {
    return apiClient.delete(`/admin/usuarios/${id}`);
  },

  resetSenha(id) {
    return apiClient.post(`/admin/usuarios/${id}/reset-senha`);
  },

  listarAuditLog({
    userId,
    entityName,
    de,
    ate,
    page = 1,
    pageSize = 50,
  } = {}) {
    const params = new URLSearchParams();
    if (userId) params.set("userId", userId);
    if (entityName) params.set("entityName", entityName);
    if (de) params.set("de", de);
    if (ate) params.set("ate", ate);
    params.set("page", String(page));
    params.set("pageSize", String(pageSize));
    return apiClient.get(`/admin/audit-log?${params.toString()}`);
  },
};

export const redefinirSenhaPorToken = (token, novaSenha) =>
  apiClient.post("/auth/redefinir-senha", { token, novaSenha });
